import React, { useState } from 'react';

function useModalState(initialValue) {
  const [value, setValue] = useState(initialValue);
  const [context, setContext] = useState(undefined);
  const setTrue = React.useCallback(val => {
    setValue(true);
    setContext(val);
  }, []);
  const setFalse = React.useCallback(() => {
    setValue(false);
    setContext(undefined);
  }, []);
  return [value, setTrue, setFalse, context];
}

export { useModalState as default };
//# sourceMappingURL=useModalState.js.map
